import { useMutation } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';
import { IWorkingInterview } from '~/reducers/permanentJobsReducer/States';
import { DraftJobPostAdapters } from '../adapters';

export const usePublishDraftJobPost = () => {
  return useMutation({
    mutationFn: ({
      id,
      workingInterviews,
    }: {
      id: string;
      workingInterviews: IWorkingInterview[];
    }) => {
      const payload = DraftJobPostAdapters.toPublishDraftJobPostPayload(workingInterviews);
      return PermanentJobsService.publishDraftJobPost(id, payload);
    },
  });
};
